import { useState } from 'react';
import type { BaseViewModel } from '../viewmodels/BaseViewModel.js';

/**
 * Instancia un ViewModel estable durante toda la vida del componente.
 *
 * Usa `useState(factory)` (initializer lazy) en vez de un ref con destroy en
 * unmount: bajo React StrictMode el ciclo setup→cleanup→setup destruía el VM
 * (completaba su BehaviorSubject) y dejaba la instancia inutilizable, por lo que
 * los inputs controlados quedaban "congelados". `useSyncExternalStore` ya limpia
 * las suscripciones al desmontar, así que no hace falta destroy() acá.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- constraint genérico: BaseViewModel<unknown> rompe por invarianza de Observer<T>
export function useViewModel<T extends BaseViewModel<any>>(factory: () => T): T {
  const [vm] = useState(factory);
  return vm;
}
